// Lines for the bracket page's "just happened" ticker, from recentEvents.json (built on
// the refresh box by tools/buildRecentEvents.mjs, which documents the event shapes).

// The quests an event can name: goals.js's ids plus the two with their own data files.
export const QUEST_NAMES = {
  monster: ['🐉', 'the Monster Quest'],
  carried: ['🤝', 'Carried by Monsters'],
  human: ['🗡️', 'the Human Quest'],
  everything: ['🌍', 'the Everything Quest'],
  gendered: ['⚥', 'the Human Gendered Quest'],
  bagel: ['🥯', 'the Everything Bagel'],
  zodiac: ['⭐', 'the Zodiac Quest'],
  raidboss: ['👹', 'the Raid Boss Quest'],
  gift: ['🎁', 'the Gift Quest'],
  loser1: ['🚪', 'First-Round Exit (Miku Quest)'],
  loser2: ['💔', 'Semifinal Heartbreak (Miku Quest)'],
  loser3: ['🥈', 'So Close (Miku Quest)'],
  loser4: ['💐', 'Always the Bridesmaid (Miku Quest)'],
};

// 1 → "1st", 22 → "22nd", 1000 → "1,000th".
export function ordinal(n) {
  const t = n % 100, s = (t >= 11 && t <= 13) ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' })[n % 10] || 'th';
  return n.toLocaleString('en-US') + s;
}

// "A, B, C and D"
const joinNames = (a) => (a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]);
const profile = (p, tab) => '?player=' + encodeURIComponent(p) + (tab ? '&tab=' + tab : '');

// One event → { emoji, who, what, href }, or null for a kind this page doesn't know
// (so an older page ignores events a newer build adds).
export function eventLine(e) {
  switch (e && e.k) {
    case 'title':
      return { emoji: '🏆', who: e.p, what: e.n === 1 ? 'won their first title!' : `won their ${ordinal(e.n)} title`, href: profile(e.p) };
    case 'quest': {
      const [emoji, name] = QUEST_NAMES[e.q] || ['🏅', 'a quest'];
      return { emoji, who: e.p, what: `completed ${name}` + (e.n > 1 ? ` for the ${ordinal(e.n)} time` : '!'), href: profile(e.p, 'achievements') };
    }
    case 'reign':
      return { emoji: '🛡️', who: joinNames(e.p || []), what: `have held the belt for ${e.n} tournaments`, href: '?crown' };
    case 'raidboss':
      return { emoji: '👹', who: e.p, what: `won a title as a raid-boss ${e.cls}`, href: profile(e.p) };
    case 'gifts':
      return { emoji: '🎁', who: e.p, what: `gave their ${ordinal(e.n)} gift`, href: profile(e.p, 'chat') };
    default:
      return null;
  }
}

// "just now" / "25 min ago" / "3h ago" / "2d ago"
export function ago(ms, now = Date.now()) {
  const min = Math.round((now - ms) / 60000);
  if (min < 1) return 'just now';
  if (min < 60) return min + ' min ago';
  const h = Math.round(min / 60);
  return h < 48 ? h + 'h ago' : Math.round(h / 24) + 'd ago';
}
